import React from 'react';
import { connect } from 'react-redux';
import {push} from "react-router-redux";
import {Link} from "react-router";
import { NotificationManager } from 'react-notifications';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {ROUTE_CLUB, ROUTE_CLUBS} from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";

import { confirm } from '../../../utils/confirmDialog';
import {nullToBlank} from "../../../../../common/src/util/lib";
import UserFieldElement from "../../reusable/UserFieldElement";
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";

class ClubsPage extends React.Component {

    static getId() {
        return ROUTE_CLUBS;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN, UserRoles.SECTION_ADMIN, UserRoles.CLUB_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            filter: '',
            showInactive: 0,
            sort: 'Foreningsnr',
        }
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getClubs());
    }

    render() {
        return this.props.admin.isClubsRead ?
            <div>
                <div className="sub-page-title">
                    <h2>Foreninger</h2>
                </div>
                <div className="sub-page-content">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th scope="row" className="clickable" onClick={() => {this.setState({sort: 'Foreningsnr'})}}>Nr</th>
                                <th className="clickable" onClick={() => {this.setState({sort: 'Sektionsnr'})}}>Sektion</th>
                                <th className="clickable" onClick={() => {this.setState({sort: 'Navn'})}}>Navn</th>
                                <th>Kommune</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.admin.clubs.sort((c1, c2) => c1.Foreningsnr < c2.Foreningsnr ? -1 : 1)
                                .filter(c => (
                                    (this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && c.Sektionsnr !== '99' && (this.state.showInactive || c.Sektionsnr === this.props.auth.currentEntity)) ||
                                    (this.props.auth.currentRole !== UserRoles.SECTION_ADMIN.id && (this.state.showInactive || c.Sektionsnr !== '99'))
                                ) && (
                                    this.state.filter === '' ||
                                    nullToBlank(c.Foreningsnr).toUpperCase().search(this.state.filter) >= 0 ||
                                    nullToBlank(c.Sektionsnr).toUpperCase().search(this.state.filter) >= 0 ||
                                    nullToBlank(c.Navn).toUpperCase().search(this.state.filter) >= 0
                                ))
                                .sort((c1, c2) =>  {
                                    const comp = (c1[this.state.sort] === null ? '' : c1[this.state.sort].trim()).localeCompare(c2[this.state.sort] === null ? '' : c2[this.state.sort].trim(), 'da-DK');
                                    return comp === 0 ? (c1.Foreningsnr < c2.Foreningsnr ? -1 : 1) : comp;
                                }).toArray().map(club => {
                                const updates = club.UpdateRequests.find(update => update.type === 'club') || null;
                                return <tr key={club.Foreningsnr} className={updates === null ? (club.UpdateRequests.length > 0 ? 'updated' : '') : (updates.key === null ? 'new' : (updates.deleted ? 'deleted' : 'updated'))} onDoubleClick={() => {
                                    this.props.dispatch(push(ROUTE_CLUB.replace(':clubNo', club.Foreningsnr).replace(':subpage', 'general').replace(':mode', 'view')));
                                }}>
                                    <th scope="row">{club.Foreningsnr}</th>
                                    <td>{club.Sektionsnr}</td>
                                    <td>{club.Navn}</td>
                                    <td>{club.Kommune}</td>
                                    <td>
                                        <Link to={this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && this.props.auth.currentEntity === club.Foreningsnr) ? ROUTE_CLUB.replace(':clubNo', club.Foreningsnr).replace(':subpage', 'general').replace(':mode', 'view') : ''} className={this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && this.props.auth.currentEntity === club.Foreningsnr) ? '' : 'disabled'} title="Vis detaljer">
                                            <i className="fa fa-file-text-o"/>
                                        </Link>
                                        <Link to={this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && this.props.auth.currentEntity === club.Foreningsnr) ? ROUTE_CLUB.replace(':clubNo', club.Foreningsnr).replace(':subpage', 'general').replace(':mode', 'edit') : ''} className={this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && this.props.auth.currentEntity === club.Foreningsnr) ? '' : 'disabled'} title="Rediger forening">
                                            <i className="fa fa-pencil"/>
                                        </Link>
                                        <i className={"fa fa-trash pointer" + (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? ' clickable' : ' disabled')} title="Slet forening" disabled={this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id} onClick={() => {
                                            if (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id) {
                                                confirm("Slet", <span>Ønsker du at slette forening <b>{club.Foreningsnr} ({club.Navn})</b>?</span>, () => {
                                                    this.props.dispatch(AdminActions.deleteClub(club.Foreningsnr, () => {
                                                        NotificationManager.success("Forening " + club.Foreningsnr + " (" + club.Navn + ") er slettet.", "Sletning", 4000);
                                                    }));
                                                });
                                            }
                                        }}/>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="sub-page-actions">
                    <Link className={"btn-primary" + (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? '' : ' disabled')} to={this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? ROUTE_CLUB.replace(':clubNo', 'new').replace(':subpage', 'general').replace(':mode', 'create') : ''} title="Opret ny forening">
                        Ny
                    </Link>
                    <label htmlFor="filter">Filter</label>
                    <UserFieldElement dataType={UserFieldDataType.string} placeholder="Indtast søgeværdi" className="field-1 large-field"
                                      name="filter" id="filter"
                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                      onChange={(e) => {
                                          const val = e.target.value.toUpperCase();
                                          //this.onStandardFieldChange(e);
                                          if (this.timeoutHandler !== null) clearTimeout(this.timeoutHandler);
                                          this.timeoutHandler = setTimeout(() => {
                                              this.setState({filter: val});
                                          }, 500);
                                      }}
                    />
                    <input id="showInactive" name="showInactive" type="checkbox" checked={this.state.showInactive} onChange = {(e) => {
                        this.setState({showInactive: e.target.checked ? -1 : 0})
                    }}/>
                    <label htmlFor="showInactive">{this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id ? "Vis alle" : "Vis inaktive"}</label>
                    <label htmlFor="sort">Sortering</label>
                    <UserFieldElement dataType={UserFieldDataType.enum} placeholder="false" className="field-1 large-field"
                                      name="sort" id="sort" value={this.state.sort} options={[
                                        {key: 'Foreningsnr', value: 'Foreningsnr'},
                                        {key: 'Sektionsnr', value: 'Sektionsnr'},
                                        {key: 'Navn', value: 'Navn'},
                                      ]}
                                      autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                      onChange={this.onStandardFieldChange}
                    />
                    <button className="btn-primary" disabled={this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id} title="Sæt junior/pensionist-markeringer automatisk fra medlem(er) for alle foreninger" onClick = {() => {
                        confirm("Opdater junior/pensionist", <span>Ønsker du at opdatere junior/pensionist-markeringer for alle slag i <b>alle</b> foreninger på basis af medlemsregistreringer?</span>, () => {
                            this.props.dispatch(AdminActions.setJuniorPensioner(() => {
                                NotificationManager.success("Junior/pensionist-markeringer er opdateret for alle slag.", "Opdatering", 4000);
                            }));
                        });
                    }}>Sæt junior/pensionist-markeringer</button>
                    <button className="btn-primary" disabled={this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id} title="Nulstil begyndermarkeringer for alle foreninger" onClick = {() => {
                        confirm("Nulstil begynder", <span>Ønsker du at nulstille begyndermarkeringer for alle slag i <b>alle</b> foreninger?</span>, () => {
                            this.props.dispatch(AdminActions.resetBeginners(() => {
                                NotificationManager.success("Alle begyndermarkeringer er nulkstillet.", "Opdatering", 4000);
                            }));
                        });
                    }}>Nulstil begyndermarkeringer</button>
                    <button className="btn-primary" disabled={this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id} title="Nulstil alle markeringer for adresseændring og tilmelding" onClick = {() => {
                        confirm("Nulstil markeringer", <span>Ønsker du at nulstille alle markeringer for adresseændring og tilmelding?</span>, () => {
                            this.props.dispatch(AdminActions.resetUpdateMarkings(() => {
                                NotificationManager.success("Alle ændringsmarkeringer er fjernet.", "Opdatering", 4000);
                            }));
                        });
                    }}>Nulstil ændringsmarkeringer</button>
                </div>
            </div> : null;
    }

    timeoutHandler = null;

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };
}

const mapStateToProps = (state) => ({
    auth: {
        isMainAdmin: state.auth.isMainAdmin,
        isSectionAdmin: state.auth.isSectionAdmin,
        isClubAdmin: state.auth.isClubAdmin,
        clubNumber: state.auth.clubNumber,
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        isClubsRead: state.admin.isClubsRead,
        clubs: state.admin.clubs
    }
});

export default connect(mapStateToProps)(ClubsPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/club/ClubsPage.js